import React, { useRef } from "react";

import VideoCover from "./VideoCover";
import { ReactComponent as ArrowDownIcon } from "../../../assets/icons/arrowDown.svg";
import { ReactComponent as ArrowUpIcon } from "../../../assets/icons/arrowUp.svg";

import "./VideosList.scss";

const ELEMENT_OFFSET = 57;

function VideosList({ videos, getVideos }) {
  const scrollRef = useRef();

  const onScroll = offset => {
    const list = scrollRef.current;
    list.scrollBy({
      top: offset,
      left: 0,
      behavior: "smooth",
    });
    if (
      list.scrollTop + list.offsetHeight >=
      list.scrollHeight - ELEMENT_OFFSET
    ) {
      if (videos.next) {
        getVideos(videos.next);
      }
    }
  };

  return (
    <div className="VideosList">
      <div className="VideosList__actions">
        <button type="button" onClick={() => onScroll(-ELEMENT_OFFSET)}>
          <ArrowUpIcon />
        </button>
      </div>
      <div className="VideosList__list" ref={scrollRef}>
        {videos.results.map(video => (
          <VideoCover key={video.id} video={video} />
        ))}
      </div>
      <div className="VideosList__actions">
        <button type="button" onClick={() => onScroll(ELEMENT_OFFSET)}>
          <ArrowDownIcon />
        </button>
      </div>
    </div>
  );
}

export default VideosList;
